import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from "./config.service";
import { timeout } from "rxjs/operators";
// import { Observable } from 'rxjs';
// import { map, take } from "rxjs/operators";

import { ArangoDoc } from "../interfaces/arango-doc";
import { BaseMap } from "../interfaces/base-map";
import { Map } from "../interfaces/map";
import { Submission } from "../interfaces/submission";
import { LatLng } from "../interfaces/lat-lng";
import { Indicator } from "../interfaces/indicator";
import { UserData } from "../interfaces/user-data";

@Injectable({
    providedIn: 'root'
})
export class DbService {
    private _APIUrl: string;

    constructor(private http: HttpClient, private config: ConfigService) {
        this._APIUrl = this.config.get("api.url");
    }

    public createMap(map: Map): Promise<any> {
        const body = { map };
        return this.http.post(this._APIUrl + "/map", body).toPromise();
    }

    public saveMapSubmission(submission: Submission): Promise<any> {
        const body = { submission };
        return this.http.post(this._APIUrl + "/submission/" + submission.mapKey, body).toPromise();
    }

    public getParcelsInRect(sw: LatLng, ne: LatLng, optimize: number = 0): Promise<any> {
        const timer = this.config.get("optimize.timeout");
        const params = new HttpParams().
            append("loc", JSON.stringify({sw, ne})).
            append("optimize", "" + optimize);

        let obs = this.http.get(this._APIUrl + "/parcelsInRect", { params });
        if (timer && timer > -1) {
            obs = obs.pipe(timeout(timer));
        }

        return obs.toPromise().catch(e => {
            if (e.name === "TimeoutError") {
                e.error = {
                    code: this.config.get("error_codes.timeout"),
                    message: e.message,
                };
            }
            throw e;
        });
    }

    public getUserMaps(): Promise<any> {
        return this.http.get(this._APIUrl + "/maps").toPromise();
    }

    public getUserMap(mapID: number | string, getSubmissions?: boolean, language?: string): Promise<any> {
        return this.http.get(this._APIUrl + "/map/" + mapID, {
            params: {
                submissions: getSubmissions === true ? "1" : "0",
                lang: ''
            }
        }).toPromise();
    }

    public getMapDashboardData(mapID: number | string): Promise<any> {
        return this.http.get(this._APIUrl + "/map/data/" + mapID).toPromise();
    }

    public exportMapData(mapIDs: string[]): Promise<any> {
        return this.http.get(this._APIUrl + "/maps/export", {
            params: {
                maps: mapIDs.join(","),
            },
            responseType: "text",
        }).toPromise();
    }

    public async getFullLeaderboard(): Promise<any> {
        const [
          submissions,
        //   maps,
        ] = await Promise.all([
            this.http.get(this._APIUrl + "/map/leaderboard").toPromise(),
            // this.http.get(this._APIUrl + "/maps").toPromise(),
        ]);
    
        // debugger;
        return { 
            submissions,
            // maps,
        };
    }

    public getLeaderboard(mapID: number | string): Promise<any> {
        return this.http.get(this._APIUrl + "/map/leaderboard/" + mapID).toPromise();
    }

    public getUsers(): Promise<any> {
        return this.http.get(this._APIUrl + "/users").toPromise();
    }

    public shareMapWithUsers(map: Map, users: string[]): Promise<any> {
        const body = new HttpParams().append("users", JSON.stringify(users));
        // TODO: don't use http params
        return this.http.post(this._APIUrl + "/map/" + map._key + "/users", body).toPromise();
    }

    public saveMap(map: any): Promise<any> {
        const body = new HttpParams().append("map", JSON.stringify(map));
        return this.http.put(this._APIUrl + "/map/" + map._key, body).toPromise();
    }

    public saveIndicatorTarget(map: Map, indicator: Indicator): Promise<any> {
        const body = new HttpParams().append("target", JSON.stringify(indicator.target));
        // TODO: don't use http params
        return this.http.post(this._APIUrl + "/map/" + map._key + "/target/" + indicator.key, body).toPromise();
    }

    public deleteMap(map: BaseMap | Map): Promise<any> {
        if (map.owner) {
            return this.http.delete(this._APIUrl + "/map/"  + map._key + "/delete").toPromise();
        }
        return this.http.delete(this._APIUrl + "/map/"  + map._key + "/shared/delete").toPromise();
    }

    public shareMap(map: BaseMap | Map): Promise<any> {
        return this.http.put(this._APIUrl + "/map/" + map._key + "/share/" + (!map.shared ? "1" : "0"), null).toPromise();
    }

    public uploadUsers(users: any, mapID: string = ""): Promise<any> {
        const body = new HttpParams()
            .append("users", JSON.stringify(users))
            .append("mapID", mapID);

        // TODO: don't use http params
        return this.http.post(this._APIUrl + "/users", body).toPromise();
    }

    public getTutorial(): Promise<any> {
        return this.http.get(this._APIUrl + "/tutorial").toPromise();
    }
}
